module.exports = __webpack_public_path__ + "img/hagrids_cake.55ef1b88.jpg";